import './App.css';
//import { AptosClient } from 'aptos';

import React, { useState, useEffect } from 'react';
import './App.css';
import arrAddress from './wladdress.json';

//const client = new AptosClient('https://fullnode.devnet.aptoslabs.com/v1');

function App() {
  // Retrieve aptos.account on initial render and store it.
  const [address, setAddress] = useState(null);
  const [eligible, setEligible] = useState('Sorry You Not Eligible on Free Mint drop');


  const connectWallet = async () => {
    if (window.aptos) {
      await window.aptos.connect()
      await window.aptos.account().then((data) => setAddress(data.address));
    } else if (window.martian) {
      await window.martian.connect()
      .then((data) => setAddress(data.address))
    } else if (window.pontem) {
      await window.pontem.connect()
      .then(address => setAddress(address))
    }
  }

  const disconnectWallet = async () => {
    if (window.aptos) {
      await window.aptos.disconnect();
    } else if (window.martian) {
      await window.martian.disconnect();
    } else if (window.pontem) {
      await window.pontem.disconnect();
    }
    setAddress(null)
    setEligible('Sorry You Not Eligible on Free Mint drop')
  }


  useEffect(() => {
    if (address !== null) {
      if (window.aptos) {
        window.aptos.account().then((data) => setAddress(data.address));
      } else if (window.martian) {
        window.martian.account().then((data) => setAddress(data.address));
      } else if (window.pontem) {
        window.pontem.account().then((address) => setAddress(address));
      }
    }
  });

  useEffect(() => {
    if (arrAddress.includes(address)) {
      setEligible('You Eligible on free mint, Congratulations 🎉')
    }
  }, [address])

  return (
    <section id="entry-page">
      <div className='main'>
        <h2>Check Your Eligible for Free Mint</h2>
        <fieldset>
          <div className='address-wrapper'>
            {address}
          </div>
        </fieldset>
        <fieldset>
          {address !== null ? eligible : "↓↓↓ Connect wallet first! ↓↓↓"}
        </fieldset>
        <button onClick={address !== null ? disconnectWallet : connectWallet}>{address !== null ? "Disconnect" : "Connect Wallet"}</button>
      </div>
    </section>
  );
}

export default App;